export default "__VITE_ASSET__DCO4tAeF__"